import vacancy_talentq from '@/stores_new/vacancy_talentq/index';

export default {
  created() {
    this.$store.registerModule('vacancy_talentq', vacancy_talentq);
  },
  destroyed() {
    this.$store.unregisterModule('vacancy_talentq');
  }
};
